import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateRole } from "@factory/query/role.query";
import { RoleFormRule, RoleFormSchema } from "@factory/form/form.rule";
import { roleFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export function useNewRole() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateRole } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Role is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addRole, isLoading: isCreating } =
    useQyCreateRole(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<RoleFormSchema>({
    defaultValues: roleFormDefault,
    resolver: zodResolver(RoleFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: RoleFormSchema) => {
    const formData = mapCreateRole(form);
    addRole(formData);
  };
  const handleValidateError = (err: FieldErrors<RoleFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
